import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface IdmeState {
  route: string | null;
  setup: string | null;
  routeEnable: boolean;
  setupEnable: boolean;
  steps: string | null;
  fetch2FaUuid: string | null;
  deviceName: string | null;
}

const initialState: IdmeState = {
  route: null,
  setup: null,
  routeEnable: false,
  setupEnable: false,
  fetch2FaUuid: null,
  steps: null,
  deviceName: null,
};

export const IdmeSlice = createSlice({
  name: "idme",
  initialState,
  reducers: {
    setRoute: (state, action: PayloadAction<string | null>) => {
      state.route = action.payload;
    },
    setSetup: (state, action: PayloadAction<string | null>) => {
      state.setup = action.payload;
    },
    setRouteEnabled: (state, action: PayloadAction<boolean>) => {
      state.routeEnable = action.payload;
    },
    setSetupEnabled: (state, action: PayloadAction<boolean>) => {
      state.setupEnable = action.payload;
    },
    setSteps: (state, action: PayloadAction<string | null>) => {
      state.steps = action.payload;
    },
    setFetch2FaUuid: (state, action: PayloadAction<string | null>) => {
      state.fetch2FaUuid = action.payload;
    },
    setDeviceName: (state, action: PayloadAction<string | null>) => {
      state.deviceName = action.payload;
    },
    clearIdmePreferenceState: (state) => {
      state.route = null;
      state.setup = null;
      state.routeEnable = false;
      state.setupEnable = false;
      state.fetch2FaUuid = null;
      state.steps = null;
      state.deviceName = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setRoute,
  setRouteEnabled,
  setSetup,
  setSetupEnabled,
  setSteps,
  clearIdmePreferenceState,
  setFetch2FaUuid,
  setDeviceName,
} = IdmeSlice.actions;

export default IdmeSlice.reducer;
